import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import qt from "../models/backend-errors.js";
import ue from "../models/braze-event.js";
import { convertMsToSeconds as l, convertSecondsToMs as Dt } from "../util/date-utils.js";
import s from "../common/event-logger.js";
import { isArray as p, isEqual as ii } from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "./storage-manager.js";

var wt = /*#__PURE__*/function () {
  function wt(t, e, s, i, r, o, n, a, h, u, c) {
    _classCallCheck(this, wt);

    this.Qi = t, this.h = e, this.Bo = s, this.v = i, this.j = r, this.gt = o, this.Ji = n, this.yo = a, this.Po = h, this.zo = u, this.Xo = c, this.$o = ["npm"];
  }

  _createClass(wt, [{
    key: "Ps",
    value: function Ps(t, e) {
      var s = this.Qi.te(),
          i = s.li(),
          r = this.h.I(o.q.Ho);
      ii(r, i) || (t.device = i), t.api_key = this.Ji, t.time = l(new Date().valueOf(), !0);
      var n = this.h.I(o.q.Yo) || [],
          a = this.h.I(o.q.Zo) || "";

      if (this.$o.length > 0 && (!ii(n, this.$o) || a !== this.j.Vo()) && (t.sdk_metadata = this.$o), t.sdk_version = this.Po, this.zo && (t.sdk_flavor = this.zo), t.app_version = this.Xo, t.device_id = s.id, e) {
        var _e = this.v.getUserId();

        null != _e && (t.user_id = _e);
      }

      return t;
    }
  }, {
    key: "Os",
    value: function Os(t, e, i) {
      var o = e.auth_error,
          n = e.error;
      if (!o && !n) return !0;

      if (o) {
        var _e2;

        this.Bo.Pn();
        var _s = {
          errorCode: o.error_code
        };

        var _iterator = _createForOfIteratorHelper(i),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            p(_t) && "X-Braze-Auth-Signature" === _t[0] && (_s.signature = _t[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        t.respond_with && t.respond_with.user_id ? _s.userId = t.respond_with.user_id : t.user_id && (_s.userId = t.user_id);
        var _n = o.reason;
        return _n ? (_s.reason = _n, _e2 = "due to ".concat(_n)) : _e2 = "with error code ".concat(o.error_code, "."), this.Bo.Gn() || (_e2 += ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'), r.D.error("SDK Authentication failed ".concat(_e2)), this.sa(t.events, t.attributes), this.Bo.Mn(_s), !1;
      }

      if (n) {
        var _i = n;

        switch (_i) {
          case qt.oa:
            var _o = "Received successful response with empty body.";
            return s.G(r.A.qs, {
              e: _o
            }), r.D.info(_o), !1;

          case qt.ha:
            var _n2 = "Received successful response with invalid JSON";
            return s.G(r.A.qs, {
              e: _n2 + ": " + e.response
            }), r.D.info(_n2), !1;

          case qt.ua:
            _i = "The API key \"".concat(t.api_key, "\" is invalid for the baseUrl ").concat(this.yo);
            break;

          case qt.ca:
            _i = "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
            break;

          case qt.la:
            _i = "No device identifier. Please contact support@braze.com";
        }

        r.D.error("Backend error: " + _i);
      }

      return !1;
    }
  }, {
    key: "fa",
    value: function fa(t, e, s, i) {
      return !!(t && 0 !== t.length || e && 0 !== e.length || s || i);
    }
  }, {
    key: "ma",
    value: function ma(t, e, s, i) {
      var r = [],
          o = function o(t) {
        return t || "";
      },
          n = o(this.v.getUserId());

      var a,
          h,
          u,
          c,
          l = this.ni(t, e);

      if (s.length > 0) {
        var _t2 = [];

        var _iterator2 = _createForOfIteratorHelper(s),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e3 = _step2.value;

            if (a = _e3.li(), this.Bo.Gn()) {
              if (n && !a.user_id) {
                c || (c = {}, c.events = []), c.events.push(a);
                continue;
              }

              if (o(a.user_id) !== n) {
                h || (h = []), h.push(a);
                continue;
              }
            }

            _t2.push(a);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _t2.length > 0 && (l.events = _t2);
      }

      if (i.length > 0) {
        var _t3 = [];

        var _iterator3 = _createForOfIteratorHelper(i),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e4 = _step3.value;
            this.Bo.Gn() && o(_e4.user_id) !== n ? (u || (u = []), u.push(_e4)) : _t3.push(_e4);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        _t3.length > 0 && (l.attributes = _t3);
      }

      if (this.sa(h, u), l = this.Ps(l, !0), c) {
        c = this.Ps(c, !1);
        var _t4 = {
          requestData: c,
          headers: this.Bs(c)
        };
        r.push(_t4);
      }

      if (l && !this.fa(l.events, l.attributes, t, e)) return c ? r : null;
      var f = {
        requestData: l,
        headers: this.Bs(l)
      };
      return r.push(f), r;
    }
  }, {
    key: "sa",
    value: function sa(t, e) {
      if (t) {
        var _e5 = [];

        var _iterator4 = _createForOfIteratorHelper(t),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _s2 = _step4.value;

            var _t5 = ue.fromJson(_s2);

            _t5.time = Dt(_t5.time), _e5.push(_t5);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.h.bo(_e5);
      }

      if (e) {
        var _iterator5 = _createForOfIteratorHelper(e),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t6 = _step5.value;
            this.h.pa(_t6);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "Vs",
    value: function Vs(t, e) {
      var s = "HTTP error ";
      null != t && (s += t + " "), s += e, r.D.error(s);
    }
  }, {
    key: "yr",
    value: function yr(t) {
      return s.G(r.A.Ra, {
        n: t
      });
    }
  }, {
    key: "ni",
    value: function ni(t, e, s) {
      var i = {};
      t && (i.feed = !0), e && (i.triggers = !0);
      var r = null != s ? s : this.v.getUserId();
      return r && (i.user_id = r), i.config = {
        config_time: this.gt.Zs()
      }, {
        respond_with: i
      };
    }
  }, {
    key: "Bs",
    value: function Bs(t, e, s) {
      var i = [["X-Braze-Api-Key", this.Ji]];
      var r = !1;

      if (null != t.respond_with && t.respond_with.triggers && (i.push(["X-Braze-TriggersRequest", "true"]), r = !0), null != t.respond_with && t.respond_with.feed && (i.push(["X-Braze-FeedRequest", "true"]), r = !0), e) {
        i.push(["X-Braze-ContentCardsRequest", "true"]);

        var _t7 = this.h.I(o.q.As);

        _t7 && s || (_t7 = 0, this.h.B(o.q.As, _t7)), i.push(["BRAZE-SYNC-RETRY-COUNT", _t7.toString()]), r = !0;
      }

      if (r && i.push(["X-Braze-DataRequest", "true"]), this.Bo.Gn()) {
        var _t8 = this.Bo.Hn();

        null != _t8 && i.push(["X-Braze-Auth-Signature", _t8]);
      }

      return i;
    }
  }, {
    key: "Gs",
    value: function Gs(t, e) {
      var s = t.device;
      s && s.os_version instanceof Promise ? s.os_version.then(function (s) {
        t.device.os_version = s, e();
      }) : e();
    }
  }, {
    key: "Qs",
    value: function Qs() {
      this.Bo.Qs();
    }
  }, {
    key: "Ks",
    value: function Ks() {
      return this.yo;
    }
  }, {
    key: "addSdkMetadata",
    value: function addSdkMetadata(t) {
      var _iterator6 = _createForOfIteratorHelper(t),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var e = _step6.value;
          -1 === this.$o.indexOf(e) && this.$o.push(e);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);

  return wt;
}();

export { wt as default };